<img *ngIf="isMobile" src="assets/svg/footer-bar-mobile.svg" class="w-full" />
<img *ngIf="!isMobile" src="assets/svg/footer-bar-txt.svg" />
<div class="w-10/12 mx-auto md:w-full">
  <div class="flex flex-col md:flex-row w-full mx-auto relative">
    <div class="flex md:hidden items-center justify-between">
      <div class="w-1/5">
        <app-logo logoClasses="h-24"></app-logo>
      </div>
      <span class="text-base md:text-lg xl:text-xl font-bold md:hidden"
        >Un contrat pour l'excellence !</span
      >
    </div>
    <div
      class="flex flex-col md:flex-row md:w-full items-stretch md:gap-1 lg:gap-8 md:justify-center"
    >
      <div class="mx-auto md:mx-0">
        <iframe
          class="map w-full md:w-11/12 lg:w-full ml-0 md:ml-0 md:mt-8 xl:ml-2 rounded-sm mx-auto"
          [src]="mapUrl"
          height="200"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>
      <div class="lg:ml-8">
        <div class="flex mt-4 md:mt-8 justify-between">
          <div class="text-xs md:font-bold">
            <p>Où nous trouver ?</p>
          </div>
          <div>
            <img
              class="w-4 md:hidden"
              (click)="showSixthItems()"
              src="../../../../assets/svg/select.svg"
            />
          </div>
        </div>
        <div *ngIf="sixthItems" class="my-4">
          <p class="text-xs mb-2">{{ settings.address_line_1 || '10 rue du Vieux Moulin,' }}</p>
          <p *ngIf="settings.address_line_2" class="text-xs mb-2">{{ settings.address_line_2 }}</p>
          <p class="text-xs mb-2">{{ settings.postal_code || '97200' }} {{ settings.city || 'Fort-de-France' }}</p>
          <p class="text-xs mb-2 font-bold">{{ settings.phone || '05 96 49 00 69' }}</p>
        </div>
      </div>
      <div>
        <div class="flex mt-4 md:mt-8 justify-between">
          <div class="text-xs md:font-bold">
            <p>À votre écoute</p>
          </div>
          <div>
            <img
              class="w-4 md:mr-0 md:hidden"
              (click)="showFirstItems()"
              src="../../../../assets/svg/select.svg"
            />
          </div>
        </div>
        <div *ngIf="firstItems" class="md:block my-4">
          <p class="text-xs mb-2 hover:underline">
            <a href="contact">Contactez notre équipe</a>
          </p>
          <p class="text-xs mb-2 hover:underline">
            <a [href]="settings.preregistration_url || 'https://airtable.com/appgMhkfcv3MmEkls/shrhYBdBDNTZ0Uk5e'" target="_blank">Fiche de pré-inscription</a>
          </p>
          <p class="text-xs hover:underline">
            <a
              [href]="accessibilityUrl"
              target="_blank"
              >Accessibilité</a
            >
          </p>
        </div>
      </div>
      <div>
        <div class="flex mt-4 md:mt-8 justify-between">
          <div class="text-xs md:font-bold">
            <p>Le CFA Santé</p>
          </div>
          <div>
            <img
              class="w-4 md:hidden"
              (click)="showSecondItems()"
              src="../../../../assets/svg/select.svg"
            />
          </div>
        </div>
        <div *ngIf="secondItems" class="my-4">
          <p class="text-xs mb-2 hover:underline">
            <a href="apprenti">Apprenti</a>
          </p>
          <p class="text-xs mb-2 hover:underline">
            <a href="employeur">Employeur</a>
          </p>
          <p class="text-xs mb-2 hover:underline">
            <a href="ufa">UFA</a>
          </p>
          <p class="text-xs mb-2 hover:underline">
            <a href="chiffres-cles">Chiffres clés</a>
          </p>
        </div>
      </div>
      <div>
        <div class="flex mt-4 md:mt-8 justify-between">
          <div class="text-xs md:font-bold">
            <p>A propos</p>
          </div>
          <div>
            <img
              class="w-4 md:hidden"
              (click)="showThirdItems()"
              src="../../../../assets/svg/select.svg"
            />
          </div>
        </div>
        <div *ngIf="thirdItems" class="my-4">
          <p class="text-xs mb-2 hover:underline">
            <a href="a-propos">Qui sommes-nous?</a>
          </p>
          <p class="text-xs mb-2 hover:underline">
            <a href="partenaires">Partenaires</a>
          </p>
          <p class="text-xs mb-2 hover:underline">
            <a href="actualites">Actualités</a>
          </p>
          <p class="text-xs mb-2 hover:underline">
            <a href="conditions-generales"
              >Conditions générales d’utilisation</a
            >
          </p>
          <p class="text-xs mb-2 hover:underline">
            <a href="politique-de-confidentialite"
              >Politique de confidentialité</a
            >
          </p>
        </div>
      </div>
      <a [href]="qualiopiCertificateUrl" target="_blank">
        <div>
          <div class="flex flex-col items-start">
            <img
              src="assets/png/LogoQualiopi.png"
              class="h-20 md:h-28 hidden md:block ml-4 md:ml-0 md:mt-8"
            />
          </div>
          <div class="hidden md:block md:mt-4">
            <p class="text-xs">
              La certification qualité a été délivrée <br />
              au titre des catégories d’actions suivantes:
            </p>
            <p class="text-xs tracking-tighter">ACTIONS DE FORMATION</p>
            <p class="text-xs tracking-tighter">
              ACTIONS DE FORMATION PAR APPRENTISSAGE
            </p>
          </div>
        </div>
      </a>
      <div *ngIf="isMobile" class="flex mt-4 md:mt-8 justify-between">
        <div class="text-xs md:font-bold mb-4">
          <p><a href="contact">Contactez-nous</a></p>
        </div>
      </div>
      <a [href]="qualiopiCertificateUrl" target="_blank">
        <div class="md:hidden mb-2">
          <img
            src="assets/png/LogoQualiopi.png"
            class="h-20 w-[40%] md:w-5/12 md:hidden"
          />
          <p class="text-xs">
            La certification qualité a été délivrée au titre des catégories
            d’actions suivantes:
          </p>
          <p class="text-xs tracking-tighter">ACTIONS DE FORMATION</p>
          <p class="text-xs tracking-tighter">
            ACTIONS DE FORMATION PAR APPRENTISSAGE
          </p>
        </div>
      </a>
    </div>
  </div>
  <div class="flex items-center justify-center lg:gap-12">
    <img
      src="assets/png/eu.png"
      alt="Union Européenne"
      class="h-16 lg:h-24"
    /><img
      src="assets/jpg/eu-m.jpg"
      alt="L'Europe s'engage en Martinique avec le FODER"
      class="h-16 lg:h-24"
    /><img
      src="assets/jpg/ctm.jpg"
      alt="Collectivité Territoriale de Martinique"
      class="h-16 lg:h-24"
    />
  </div>
</div>
<hr />
<div>
  <p class="text-sm text-center mt-4 md:mt-8">
    © 2024 - CFA Santé Martinique - Tous droits réservés
  </p>
</div>
